module.exports = __webpack_public_path__ + "img/loading-icon.0c137e47.gif";